function minus (val) {
  if (val || val === 0) return val

  return '-'
}

function toNum (value) {
  if (typeof value === 'number') return value
  return +comma2Dot(value)
}

function comma2Dot (value) {
  if (typeof value === 'number') return value

  if (value) {
    return value.replace(/,/g, '.')
  }

  return value
}

function fullName (surname = '', name = '') {
  return `${ucFirst(surname)} ${ucFirst(name)}`.trim()
}

function ucFirst (str) {
  if (!str) return ''

  return str[0].toUpperCase() + str.slice(1)
}

function isString (value) {
  return typeof value === 'string'
}

function checkAndSliceIds (str) {
  return str.endsWith('_ids') ? sliceIds(str) : str
}

function sliceIds (str) {
  return str.slice(0, -4) // - _ids
}

function clearValuePOrM (value) {
  if (value) value = value.replace(/[^\d.,]/g, '')
  return toNum(value)
}

const ALLOWED_TAGS = [
  'p',
  'br',
  'strong',
  'em',
  'u',
  's',
  'span',
  'ul',
  'ol',
  'li'
]
function sanitizeHtml (html) {
  if (!html) return ''

  const parser = new DOMParser()
  const doc = parser.parseFromString(html, 'text/html')

  const walk = (node) => {
    [...node.children].forEach(child => {
      const tag = child.tagName.toLowerCase()

      if (!ALLOWED_TAGS.includes(tag)) {
        // заменяем запрещённый тег на его содержимое
        child.replaceWith(...child.childNodes)
      } else {
        walk(child)
      }
    })
  }

  walk(doc.body)
  return doc.body.innerHTML
}

export {
  minus,
  toNum,
  comma2Dot,
  fullName,
  ucFirst,
  isString,
  checkAndSliceIds,
  sliceIds,
  clearValuePOrM,
  sanitizeHtml
}
